export default __webpack_public_path__ + "static/media/Nimbus Nome.59e40e41.svg";